import { render, staticRenderFns } from "./WebPartnerUpsertCategoryConfig.vue?vue&type=template&id=abbf169c"
import script from "./WebPartnerUpsertCategoryConfig.vue?vue&type=script&lang=js"
export * from "./WebPartnerUpsertCategoryConfig.vue?vue&type=script&lang=js"
import style0 from "./WebPartnerUpsertCategoryConfig.vue?vue&type=style&index=0&id=abbf169c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports